// Convert data URL to Blob
function dataURLToBlob(dataUrl) {
  // Split out the mime type and base64 data
  const [header, base64] = dataUrl.split(',');
  const mimeMatch = header.match(/:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : 'image/png';
  const binary = atob(base64);
  const array = [];
  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], {
    type: mime
  });
}

// Usage with ClipboardItem API
export async function copyImageToClipboard(dataUrl) {
  if (!navigator.clipboard) {
    alert('Clipboard API not supported');
    return;
  }
  try {
    const blob = dataURLToBlob(dataUrl);
    if (navigator.clipboard.write) {
      // Chrome, Edge: works
      await navigator.clipboard.write([new ClipboardItem({
        [blob.type]: blob
      })]);
    } else {
      alert('Image copy not supported in this browser. Right-click the image to copy.');
    }
  } catch (err) {
    console.error('Copy failed:', err);
  }
}